module.exports = __webpack_public_path__ + "static/media/VAI-BUSD.67c991ef.svg";